import { PagedSingleSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { categoryService } from "../api";

interface Props {
	name: string;
	label: string;
	clearable?: boolean;
	required?: boolean;
	disabled?: boolean;
}

const fetchConfig = laravelServiceSelectFetchConfig(categoryService);

export const CategorySingleSelect: FC<Props> = ({ name, label, clearable, required, disabled }) => {
	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			clearable={clearable}
			required={required}
			disabled={disabled}
			fetchConfig={fetchConfig}
		/>
	);
};
